import React from 'react';
import { observer } from 'mobx-react-lite';
import Switch from 'react-switch';
import { useTranslation } from 'react-i18next';
import styles from './AutoReplyCustomAwayMessageSwitches.module.css';
import { useRootStore } from '../../../../../mobx/bridge';
import AutoReplyWarningMessage from '../AutoReplyWarningMessage/AutoReplyWarningMessage';
import * as utils from '../../../../../helpers/utils';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyCustomAwayMessageSwitches = observer(function AutoReplyCustomAwayMessageSwitches(
  props
) {
  const { commonStore, sendingEvents } = useRootStore();
  const switchTextChat = React.useRef(null);
  const switchWebChat = React.useRef(null);

  const { t } = useTranslation();
  const { data, hasAutoReplyExpired } = props;

  const changeIsActiveForTextChat = () => {
    commonStore.setConflictingAutoReplies(null);

    if (!data.IsActiveForTextChat) {
      commonStore.setSelectedAutoReplySwitch(switchTextChat.current);
      commonStore.setSelectedMessageTypeId(utils.MessageTypeEnum.SMS.TypeId);
    }

    sendingEvents.socketEmitToggleAutoReplyIsActiveForTextChat(data);
  };

  const changeIsActiveForWebChat = () => {
    commonStore.setConflictingAutoReplies(null);

    if (!data.IsActiveForWebChat) {
      commonStore.setSelectedAutoReplySwitch(switchWebChat.current);
      commonStore.setSelectedMessageTypeId(utils.MessageTypeEnum.DirectMessage.TypeId);
    }

    sendingEvents.socketEmitToggleAutoReplyIsActiveForWebChat(data);
  };

  const closeConfirmAutoReplyWindow = () => {
    if (commonStore.selectedAutoReplySwitch) {
      commonStore.setSelectedAutoReplySwitch(null);
      commonStore.setSelectedMessageTypeId(null);
    }
  };

  const onSwitchStyle = [styles.dot, styles.green].join(' ');
  const offSwitchStyle = [styles.dot, styles.gray].join(' ');

  const offHandleIcon = (
    <div className={styles.handleIconContainer}>
      <span className={offSwitchStyle} />
    </div>
  );

  return (
    <>
      <div>
        {commonStore.getHasAccessToTextChats ? (
          <div className={styles.switchContainer}>
            <Switch
              disableTouch
              onChange={changeIsActiveForTextChat}
              checked={data?.IsActiveForTextChat && !hasAutoReplyExpired}
              className={styles.switch}
              height={19}
              width={31}
              handleDiameter={15}
              offColor="#9a9b99"
              onColor="#9a9b99"
              uncheckedIcon={false}
              checkedIcon={false}
              uncheckedHandleIcon={offHandleIcon}
              checkedHandleIcon={
                <div ref={switchTextChat} className={styles.handleIconContainer}>
                  <span className={onSwitchStyle} />
                </div>
              }
            />
            <span className={styles.switchLabel}>{t('AutoReplyModalWindow.TextChat')}</span>
          </div>
        ) : null}
        {commonStore.getHasAccessToWebChats && commonStore?.isWebchatEnabled ? (
          <div className={styles.switchContainer}>
            <Switch
              disableTouch
              onChange={changeIsActiveForWebChat}
              checked={data?.IsActiveForWebChat && !hasAutoReplyExpired}
              className={styles.switch}
              height={19}
              width={31}
              handleDiameter={15}
              offColor="#9a9b99"
              onColor="#9a9b99"
              uncheckedIcon={false}
              checkedIcon={false}
              uncheckedHandleIcon={offHandleIcon}
              checkedHandleIcon={
                <div ref={switchWebChat} className={styles.handleIconContainer}>
                  <span className={onSwitchStyle} />
                </div>
              }
            />
            <span className={styles.switchLabel}>{t('AutoReplyModalWindow.WebChat')}</span>
          </div>
        ) : null}
      </div>
      {commonStore.selectedAutoReplySwitch &&
      commonStore?.conflicts?.scheduleConflicts &&
      commonStore?.conflicts?._id === data._id ? (
        <AutoReplyWarningMessage
          data={data}
          selectedAutoReplyType={utils.AutoReplyTypeEnum.CustomAwayMessage.TypeId}
          onClose={closeConfirmAutoReplyWindow}
        />
      ) : null}
    </>
  );
});
AutoReplyCustomAwayMessageSwitches.whyDidYouRender = true;
AutoReplyCustomAwayMessageSwitches.displayName = 'AutoReplyCustomAwayMessageSwitches';

export default AutoReplyCustomAwayMessageSwitches;
